export enum UpdateActionResult {
	Unknown = 'Unknown',
	Success = 'Success',
	DownloadFailed = 'DownloadFailed',
	InstallFailed = 'InstallFailed'
}
